<template>
  <div class="form-step-4">
    <div class="section-subtitle">Данные организации</div>
    <v-btn @click="$emit('back')" class="btn-blue mb-8" color="primary">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.70711 1.70711C8.09763 1.31658 8.09763 0.683418 7.70711 0.292893C7.31658 -0.0976311 6.68342 -0.0976311 6.29289 0.292893L7.70711 1.70711ZM1 7L0.292893 6.29289C-0.0976312 6.68342 -0.0976313 7.31658 0.292893 7.70711L1 7ZM6.29289 13.7071C6.68342 14.0976 7.31658 14.0976 7.70711 13.7071C8.09763 13.3166 8.09763 12.6834 7.70711 12.2929L6.29289 13.7071ZM6.29289 0.292893L0.292893 6.29289L1.70711 7.70711L7.70711 1.70711L6.29289 0.292893ZM0.292893 7.70711L6.29289 13.7071L7.70711 12.2929L1.70711 6.29289L0.292893 7.70711Z" fill="#fff"/>
      </svg>
      <span class="ml-3">Вернуться к персональным данным</span>
    </v-btn>

    <v-form
      class="auth-form"
      ref="form4"
      v-model="valid"
    >
      <div class="auth-form--wrap">
        <div class="input-label">Тип пользователя <i class="color-red">*</i></div>
        <v-select
          v-model="formData.type_id"
          :items="types"
          item-value="id"
          item-text="title"
          outlined
          class="custom-select"
          required
          :rules="[rules.required]"
        />
      </div>

      <div v-if="type && type.is_organization">
        <div class="auth-form--wrap">
          <div class="input-label">ИНН <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.inn"
            v-mask="'#'.repeat(type.inn_length)"
            :clearable="true"
            :open-on-clear="true"
            hide-details
            hide-no-data
            :rules="[rules.ifOrganization]"
            outlined
            required
            dense
          />
        </div>

        <div class="auth-form--wrap">
          <div class="input-label">Название ИП/Организации <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.companyName"
            outlined
            dense
            disabled
            required
            :rules="[rules.ifOrganization]"
          />
        </div>
        <div class="auth-form--wrap">
          <div class="input-label">Сайт организации <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.companySite"
            :rules="[rules.ifOrganization]"
            outlined
            dense
            hide-details
          />
          <div class="size-14 color-grey mb-4 mt-2">Если у Вашей организации нет сайта, укажите «нет»</div>
        </div>
      </div>

      <v-btn
        class="w-100 btn-blue"
        color="primary"
        :disabled="!valid"
        @click="Submit()"
      >
        Зарегистрироваться
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'FormStep4',
  props: ['form'],
  data() {
    return {
      types: [],
      companies: [],
      valid: false,
      rules: {
        ifOrganization: v => (!this.type.is_organization || !!v) || 'Поле должно быть заполнено',
        required: v => !!v || 'Поле должно быть заполнено',
      },
      formData: {
        type_id: null,
        inn: '',
        companyName: '',
        companySite: '',
      },
    };
  },
  computed: {
    type() {
      return this.types.find(el => el.id === this.formData.type_id);
    },
  },
  methods: {
    // /** Валидация формы */
    Validate() {
      const formValidation = this.$refs.form.reportValidity();
      const maskValidation = this.type && this.type.is_organization
        ? this.formData.inn.length === this.type.inn_length
        : true;

      this.valid = (formValidation && maskValidation);
    },
    loadTypes() {
      const app = this;
      return app.$store.getters.axl.post('profiles/api/profiles/types')
        .then((res) => {
          const { items } = res.data;
          this.types = items || [];
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    Submit() {
      if (this.type.is_organization) {
        this.$emit('submit', this.formData);
      } else {
        this.$emit('submit', { type_id: this.type.id });
      }
    },
    validateField() {
      // console.log('sdsddfsd', this.$refs);
      // this.$refs.form4.validate();
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'formData.inn': function (val) {
      this.formData.companyName = '';
      if (val && val.length >= this.type.inn_length) {
        this.$store.getters.axl.post('profiles/api/dealers/find-by-inn', { inn: val, type_id: this.type.id })
          .then((result) => {
            const company = result.data.data;
            if (company) {
              this.formData.companyName = company.organization_name;
            }
          })
          .catch((error) => {
            this.$store.dispatch('HandleError', error);
          });
      }
    },
    'formData.type_id': 'validateField',
  },
  mounted() {
    this.loadTypes();
  },
};
</script>

<style scoped lang="scss">

</style>
